import React from 'react';

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
// pages
import {Home} from './Home';
import {About} from './About';
import {Contacts} from './Contacts';
import {Employess} from './Employess';
// navbar 
import Navbar from './Navbar';

function Pages() {
    return (
    <Router>
        <Navbar/>
        <Switch>
           <Route exact path="/">
                  <Home/>
           </Route>
           <Route path="/about">
               <About/>
           </Route>
           <Route path="/employess">
              <Employess/>
           </Route>
           <Route path="/contacts">
              <Contacts/>
           </Route>
      </Switch>  
            
    </Router>
    );    
}

 export default Pages;
